import { render, staticRenderFns } from "./portraitDetail.vue?vue&type=template&id=8b356b04&scoped=true"
import script from "./portraitDetail.vue?vue&type=script&lang=js"
export * from "./portraitDetail.vue?vue&type=script&lang=js"
import style0 from "./portraitDetail.vue?vue&type=style&index=0&id=8b356b04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b356b04",
  null
  
)

export default component.exports